import React from 'react';
import { useToolbarOverflowMenuClose } from './Toolbar';
import { MenuItem } from '../../../components/Menu';
import trashIcon from '../../../icons/non-prefilled/16x16/trash.svg';

interface DeleteMenuItemProps {
  children: React.ReactNode;
  onClick: () => void;
}

const DeleteMenuItem = ({ onClick, children }: DeleteMenuItemProps) => {
  const closeOverflowMenu = useToolbarOverflowMenuClose();

  return (
    <MenuItem
      icon={trashIcon}
      onClick={() => {
        onClick();
        closeOverflowMenu();
      }}
      danger
    >
      {children}
    </MenuItem>
  );
};

export default DeleteMenuItem;
